var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3922 11.015C17.6277 9.443 16.4299 8.59775 14.7934 8.03375L15.3244 5.90375L14.0284 5.58125L13.5109 7.655C13.1704 7.5695 12.8209 7.49 12.4722 7.4105L12.9934 5.32325L11.6974 5L11.1664 7.12925C10.8839 7.06575 10.6079 7.00075 10.3384 6.93425L10.3399 6.9275L8.55191 6.48125L8.20691 7.86575C8.20691 7.86575 9.16916 8.08625 9.14891 8.09975C9.67391 8.231 9.76841 8.57825 9.75266 8.85425L9.14816 11.2805C9.18466 11.289 9.22966 11.3032 9.28316 11.3232L9.14591 11.2895L8.29841 14.6885C8.23391 14.8475 8.07116 15.0867 7.70366 14.996C7.71716 15.0147 6.76166 14.7612 6.76166 14.7612L6.11816 16.2448L7.80566 16.6655C8.11916 16.7443 8.42666 16.8267 8.72891 16.904L8.19266 19.058L9.48791 19.3805L10.0189 17.2505C10.3724 17.3455 10.7169 17.4347 11.0524 17.5182L10.5229 19.6392L11.8189 19.9618L12.3552 17.8123C14.5662 18.2308 16.2282 18.062 16.9279 16.0625C17.4919 14.453 16.9002 13.5238 15.7369 12.9185C16.5844 12.7235 17.2219 12.1663 17.3922 11.015ZM14.4297 15.1685C14.0299 16.7788 11.3187 15.908 10.4397 15.6898L11.1522 12.836C12.0312 13.0557 14.8489 13.49 14.4297 15.1685ZM14.8309 10.9918C14.4657 12.4565 12.2097 11.7118 11.4784 11.5295L12.1234 8.942C12.8547 9.12425 15.2119 9.464 14.8309 10.9918Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.bc5fcbaff7119ddc72f2667f1f07cf23.svg";
export { ForwardRef as ReactComponent };